// extracted by mini-css-extract-plugin
export default {"wrap":"Login_wrap__HPBY4","card":"Login_card__gWlrO","logo":"Login_logo__tBTNk","sub":"Login_sub__7HRGS","error":"Login_error__pq6E7","submit":"Login_submit__dHGUP"};